import ReactDOM from 'react-dom';

import {ENVDefaultObj, POInfoObj} from './dataObj.js';

export function updateENVFn (selectThis, source) {
  selectThis.env = new ENVDefaultObj().env;
  Object.keys(source).map((entry) => {
    switch (entry)
    {
    case 'styleObj':
      Object.keys(source.styleObj).map((node_entry) => {
        selectThis.env.styleObj[node_entry] = {};
        Object.keys(source.styleObj[node_entry]).map((style_entry) => {
          let camelCaseStyleName = camelCaseTransformerFn(style_entry);
          selectThis.env.styleObj[node_entry][camelCaseStyleName] = source.styleObj[node_entry][style_entry];
        });
      });
      break;
    case 'addtionalButton':
    case 'featureSearch':
      Object.keys(source[entry]).map((modeObj_entry) => {
        selectThis.env[entry][modeObj_entry] = source[entry][modeObj_entry];
      });
      break;
    default:
      selectThis.env[entry] = source[entry];
      break;
    }
  });
  selectThis.printoutData = new POInfoObj(selectThis.env.selectorId).printout;
  selectThis.searchStatusArr = dataSearching(selectThis);

  function camelCaseTransformerFn (orinal_name) {
    let newName = '';
    newName = orinal_name.replace(/-(\w)/g, 
      function(all, letter) {
        return letter.toUpperCase();
      }
    );
    return newName;
  }
}
export function dataSearching (selectThis) {
  let searchStatusArr = [];
  let searchConfig = {
    enable                    : selectThis.env.featureSearch.enable,
    searchInput               : selectThis.printoutData.inputValue,
    searchMatchRateTheshold   : 1,
    searchSpecAttributeEnable : selectThis.env.featureSearch.searchSpecAttributeEnable,
    searchSpecAttributeArr    : selectThis.env.featureSearch.searchSpecAttributeArr
  };
  let attributeArr = [];
  let matchArr = [];
  let headArr = selectThis.env.optionHeadArr;
  let bodyArr = selectThis.env.optionBodyArr;
  if ((searchConfig.enable)
    && ('' !== searchConfig.searchInput)
  )
  {
    if (searchConfig.searchSpecAttributeEnable)
    {
      attributeArr = searchConfig.searchSpecAttributeArr.slice(0);
    }
    else
    {
      attributeArr = headArr.map((entry) => {
        return entry.index;
      });
    }
    matchArr = bodyArr.map((data) => {
      let matchCounter = 0;
      for (let i =0; i < attributeArr.length; i++)
      {
        if (data[attributeArr[i]].toString().match(searchConfig.searchInput)) {
          matchCounter += 1;
          break;
        }
      }
      return matchCounter;
    });
    searchStatusArr = matchArr.map((entry) => {
      return (searchConfig.searchMatchRateTheshold <= entry);
    });
  }
  else
  {
    searchStatusArr = bodyArr.map(() => {
      return true;
    });
  }
  return searchStatusArr;
}
export function resultFn (searchStatusArr, source) {
  let resultArr = [];
  source.map((entry, index) => {
    if (searchStatusArr[index])
    {
      resultArr.push(entry);
    }
  });
  return resultArr;
}
export function autoSelectFn (selectThis) {
  let data = resultFn(selectThis.searchStatusArr, selectThis.env.optionBodyArr);
  if ((selectThis.env.featureSearch.enable) 
    && ('' != selectThis.printoutData.inputValue)
  )
  {
    if (0 < data.length) {
      selectThis.printoutData.selectedOption = data[0];
      selectThis.printoutData.inputValue = data[0][selectThis.env.indexAttribute];
    }
    else {
      selectThis.printoutData.selectedOption = {};
      selectThis.printoutData.inputValue = '';
    }
  }
  ReactDOM.findDOMNode(selectThis.refs.searchInput).value = selectThis.printoutData.inputValue;
  selectThis.searchStatusArr = dataSearching(selectThis);
}
export function valuePrintoutFn (selectThis) {
  selectThis.env.printoutFn(selectThis.printoutData);
}
export function clickListenerFn(selectThis, event) {
  let target = event.target;
  let target_parentClasaName = target.parentNode.className;
  let target_pparentClasaName = target.parentNode.parentNode.className;
  let target_ppparentClasaName = target.parentNode.parentNode.parentNode.className;
  if ((selectThis.env.selectorId !== target.id)
        && (`${selectThis.env.selectorId}_button` !== target.id)
  )
  {
    if ((-1 === target_parentClasaName.search('optionList-body'))
          && (-1 === target_pparentClasaName.search('optionList-body'))
          && (-1 === target_ppparentClasaName.search('optionList-body'))
    )
    {
      if (selectThis.refs.searchInput)
      {
        ReactDOM.findDOMNode(selectThis.refs.searchInput).value = selectThis.printoutData.inputValue;
      }
    }
    optionsSwitchFn(selectThis, false);
  }
}
export function optionsSwitchFn (selectThis, turn) {
  let isShowingOptions = false;
  document.removeEventListener("click", selectThis.__clickListenerFn);
  if (turn)
  {
    isShowingOptions = true;
    document.addEventListener("click", selectThis.__clickListenerFn);
  }
  else
  {
    isShowingOptions = false;
    autoSelectFn(selectThis);
    valuePrintoutFn(selectThis);
  }
  selectThis.optionsActive = isShowingOptions;
  selectThis.forceUpdate();
}
export function refHandler (selectThis, ref) {
  selectThis.env.refFn(ref);
}
export function inputOnChangeHandler (selectThis, actionType) {
  let inputValue = '';
  switch (actionType)
  {
  case 'set':
    inputValue = ReactDOM.findDOMNode(selectThis.refs.searchInput).value;
    break;
  default:
    inputValue = '';
    break;
  }
  selectThis.printoutData.inputValue = inputValue;
  ReactDOM.findDOMNode(selectThis.refs.searchInput).value = inputValue;
  selectThis.searchStatusArr = dataSearching(selectThis);
  selectThis.forceUpdate();
}
export function optionOnClickHandler (selectThis, optionObj) {
  if (optionObj[selectThis.env.indexAttribute])
  {
    selectThis.printoutData.selectedOption = optionObj;
    selectThis.printoutData.inputValue = optionObj[selectThis.env.indexAttribute];
  }
  else
  {
    selectThis.printoutData.selectedOption = {};
    selectThis.printoutData.inputValue = '';
  }
  ReactDOM.findDOMNode(selectThis.refs.searchInput).value = selectThis.printoutData.inputValue;
  selectThis.searchStatusArr = dataSearching(selectThis);
  optionsSwitchFn(selectThis, false);
  selectThis.forceUpdate();
}
